import React from 'react';
import css from './SignupForm.module.css';

import SignUpOptionsPage from './SignUpOptionsPage';
import SignUpBanner from './SignUpBanner';
import SignupForm from './SignupForm';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { parse } from '../../../util/urlHelpers';
import { FormattedMessage } from 'react-intl';

const EMAIL_FLOW = 'email';

function SignupRootPageComponent(props) {
  const { location, history } = props;
  const { flw: signUpFlow } = parse(location.search);
  return (
    <div className={css.mainContainer}>
      <div className={css.leftContainer}>
        <SignUpBanner />
      </div>
      <div className={css.rightContainer}>
        {signUpFlow && signUpFlow === EMAIL_FLOW ? (
          <SignupForm {...props} />
        ) : (
          <SignUpOptionsPage history={history} {...props} />
        )}
        <div className={css.termsSection}>
          <FormattedMessage id="SignUpAndLogin.TNC" />
        </div>
      </div>
    </div>
  );
}

const SignupRootPage = compose(withRouter)(SignupRootPageComponent);

export default SignupRootPage;
